<template>
  <div class="user_transfer">
    <el-transfer
      class="min_cla"
      filterable
      :filter-method="filterMethod"
      :filter-placeholder="$t('common.inputUserName')"
      v-model="targetData"
      @change="handleChange"
      :data="resourceData"
      :titles="titles"
    ></el-transfer>
  </div>
</template>
<script>
import { getAllUsers } from '../../../services/user.js'
export default {
  name: 'ZkUserTransfer',
  data() {
    return {
      titles: [this.$t('common.sourceList'), this.$t('common.targetList')],
      resourceData: [],
      targetData: []
    }
  },
  props: ['selectedData'],
  methods: {
    filterMethod(query, item) {
      let trim = (str) => {
        return str.replace(/^(\s*)|(\s*)$/g, '')
      }
      if (query === '' || query === null || query === undefined) {
        return true
      }
      if (item.label && item.label.indexOf(trim(query)) > -1) {
        return true
      }
      if (item.name && item.name.indexOf(trim(query)) > -1) {
        return true
      }
      return false
    },
    query() {
      let self = this
      getAllUsers({
        params: {},
        pager: {
          curPage: 1,
          pageSize: 3000
        }
      }).then((data) => {
        let results = data.payload.results.results || data.payload.results
        results.forEach((item) => {
          self.resourceData.push({
            key: item.id,
            label: item.loginName,
            name: item.name
          })
        })
      })
    },
    getSelect() {
      return this.targetData
    },
    handleChange(data) {
      this.targetData = data
    },
    createSelectData() {
      this.targetData = []
      if (this.selectedData) {
        this.selectedData.forEach((item) => {
          this.targetData.push(item.key)
        })
      }
    }
  },
  watch: {
    selectedData(val) {
      this.targetData = []
      val.forEach((item) => {
        this.targetData.push(item.key)
      })
    }
  },
  mounted() {
    this.query()
    this.createSelectData()
  }
}
</script>
<style lang="less">
.user_transfer {
  .min_cla {
    display: flex;
    align-items: center;
  }
  label[role='checkbox'] {
    display: block;
  }
  .el-transfer {
    width: 100%;
  }
  .el-transfer-panel {
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/userTransfer/src/main.vue